import { useContext } from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { DataContext } from '../../contexts/data/dataContext'
import custom from '../../styles/mui/szVariables.json'

export default function Welcome({ handleClose }: any) {
  const data = useContext(DataContext)
  if(data?.customer?.hasUsageData===false) return null;
  return (
      <Paper id="welcome" elevation={0} 
            sx={{ 
              borderRadius: custom.corners5, 
              border: custom.border,
              maxWidth: "100%",
              backgroundColor: '#E3FCEF',
              p: custom.spacing.lg,
            }}
        >
          <Stack alignItems="flex-start" justifyContent="center" direction="row" >
              <Box
                component={'img'}
                id="CheckIcon"
                alt="check icon"
                src="/images/CheckIcon.svg"
                height={'32px'}
                width={"32px"}
              />
              <Typography component="p" 
                  width="100%"
                  ml={custom.spacing.sm}
                  mt={custom.spacing.xxs}
                  variant="szHeading.Bold.Medium">
                  Check out our new features​
              </Typography>
              <Box
                  id="closeWelcome"
                  onClick={handleClose}
                  ml="auto"
                  border={custom.border}
                  p={custom.spacing.xxxs}
                  borderRadius={custom.corners3}
                  sx={{ 
                      backgroundColor: '#FFF',
                      cursor: 'pointer',
                      mr: -2,
                      mt: -2
                   }}
                  component="img"
                  src="/images/X.svg" 
              />
          </Stack>
          <Box display="flex" maxWidth="100%" ml={6}>
              <Typography component="p"
                width="100%" 
                mt={custom.spacing.xxs}
                variant="szBody.Regular.Medium">
                You can now access historical energy data to understand how you are using energy across the week. Plus, download your Sunshine Savings Reports. Make sure to have a look around.
            </Typography>
        </Box>
      </Paper>
  )
}
